import styled from '@emotion/styled'
import { color, typography, ExternalButtonLink } from 'stylist'

const FooterLink = styled(ExternalButtonLink)`
  color: ${color('white')};
  border-color: transparent;
  background-color: transparent;

  ${typography('body1Medium')};

  &:hover {
    color: ${color('silver')};
  }
`

export default FooterLink



// WEBPACK FOOTER //
// ./src/routes/components/FooterLink.js